import parseHTML from '../utils/_parseHtml';
import { addPageAttributeToTiles } from '../utils/_grid';
import wishlist from '../utils/_wishlist';

class mLoadPrevious extends HTMLDivElement {
    constructor() {
        super();
        this.loadPreviousBtn = this.querySelector('button');
        this.plpGrid = this.parentElement.querySelector("[is='o-plp-grid']");
        this.seenProductsComponent = this.parentElement.querySelector("[is='m-see-more']");
        this.seenProductsParagraph = this.seenProductsComponent.querySelector("[is='m-see-more'] p");
    }

    connectedCallback() {
        this.loadPreviousBtn.addEventListener('click', () => {
            this.loadPreviousProducts();
        });
    }

    loadPreviousProducts() {
        if (this.loadPreviousBtn.disabled) {
            return false;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const currentPage = urlParams.get('page');

        if (currentPage) {
            addPageAttributeToTiles(this.plpGrid, currentPage);

            document.dispatchEvent(new CustomEvent('oPlpGrid:addPageUrl', {
                detail: {
                    pageNumber: currentPage,
                    pageUrl: window.location.href,
                },
            }));
        }

        this.loadPreviousBtn.setAttribute('disabled', '');

        const { url } = this.loadPreviousBtn.dataset;
        const newPLP = this.loadPreviousBtn.dataset.newPlp === 'true';

        const data = {
            selectedUrl: url, // not sure if this has any use case
            seenProducts: this.seenProductsComponent.dataset.seenProducts,
        };

        fetch(`${url}&newPLP=${newPLP}&${new URLSearchParams(data)}`, {
            Method: 'GET',
        }).then((response) => response.text(), // convert response to string
        ).then((responseString) => {
            const responseData = this.getResponseGridData(responseString);
            this.updateLoadPreviousBtnButtonData(responseData);
            this.loadPreviousBtn.removeAttribute('disabled');
            this.plpGrid.prepend(responseData.html);

            wishlist.activateWishlistHeartButtons(); // Activate wishlist button for new loaded products

            if (responseData && responseData.pageNumber) {
                document.dispatchEvent(new CustomEvent('oPlpGrid:addPageUrl', {
                    detail: {
                        pageNumber: responseData.pageNumber,
                        pageUrl: responseData.currentUrl,
                    },
                }));
            }
            document.dispatchEvent(new CustomEvent('oPlpGrid:initUrlUpdate'), {
                detail: {
                    pageNumber: responseData.pageNumber,
                },
            });
        });

        return true;
    }

    // When requesting the first page of a product list, we load the Search-Show endpoint
    // to have the push images. This function get the current index of plp in the page if
    // there are multiple product lists. In that case, we use this index to get the correct
    // product list in the return of the Search-Show endpoint
    getProductListIndex() {
        const productLists = document.querySelectorAll('.experience-dynamic-productListV2');
        const closestProductList = this.closest('.experience-dynamic-productListV2');
        let index = 0;
        if (productLists) {
            productLists.forEach((pl, i) => {
                if (pl === closestProductList) {
                    index = i;
                }
            });
        }
        return index;
    }

    getResponseGridData(res) {
        const currentProductListIndex = this.getProductListIndex();
        let parsedHtml = parseHTML(res);
        // Store data in JS and delete element
        const productListLayout = parsedHtml.querySelector('.experience-dynamic-productList');
        const productListLayoutV2 = parsedHtml.querySelector('.experience-dynamic-productListV2');

        if (productListLayout) {
            parsedHtml = parseHTML(productListLayout.innerHTML);
        }
        if (productListLayoutV2) {
            parsedHtml = parseHTML(productListLayoutV2.innerHTML);
        }
        const jsPaginations = parsedHtml.querySelectorAll('.js-pagination');
        const jsPaginationIndex = Math.min(jsPaginations.length - 1, currentProductListIndex);
        const jsPagination = jsPaginations[jsPaginationIndex];
        // Remove pagination data from html before insertion in the DOM
        if (jsPagination) {
            const parentElt = jsPagination.parentElement || parsedHtml;
            parentElt.removeChild(jsPagination);
            // add currentPageNumber to new tiles
            parsedHtml = addPageAttributeToTiles(parsedHtml, jsPagination.dataset.pageNumber);
            const productLists = parsedHtml.querySelectorAll('.experience-dynamic-productListV2');
            const index = Math.min(productLists.length - 1, currentProductListIndex);
            const experienceElt = productLists[index];
            if (experienceElt) {
                parsedHtml = parseHTML(experienceElt.innerHTML);
            }
            return {
                html: parsedHtml,
                pageNumber: jsPagination.dataset.pageNumber,
                currentUrl: jsPagination.dataset.currentUrl,
                pageSize: jsPagination.dataset.pageSize,
                sortOptionString: jsPagination.dataset.sortOptions,
                sortOption: JSON.parse(jsPagination.dataset.sortOptions),
                nextBtnUrl: jsPagination.dataset.nextBtnUrl,
                prevBtnUrl: jsPagination.dataset.prevBtnUrl,
                seenProducts: jsPagination.dataset.seenProducts,
                seenProductsWording: jsPagination.dataset.seenProductsWording,
            };
        }
        return false;
    }

    updateLoadPreviousBtnButtonData(object) {
        if (object.prevBtnUrl === '') {
            this.setAttribute('hidden', '');
        }
        this.loadPreviousBtn.dataset.url = object.prevBtnUrl;
        this.seenProductsComponent.dataset.seenProducts = object.seenProducts;
        this.seenProductsParagraph.innerText = object.seenProductsWording;
    }
}

customElements.define('m-load-previous', mLoadPrevious, {
    extends: 'div',
});
